"use client";
import Heart from "@/components/icons/Heart";
import useModal from "@/lib/hooks/useModal";
import { ItemId, useWishlist } from "@/lib/wishlist/hooks";
import clsx from "clsx";
import styles from "./wishlist.module.css";

interface IWishlistButtonProps {
  itemId?: ItemId;
  sizeItemId?: string;
  className?: string;
}

export const WishlistButton = ({
  itemId,
  sizeItemId,
  className,
}: IWishlistButtonProps) => {
  const { has, toggle } = useWishlist();
  const isActive = has(itemId);
  const modal = useModal("wishlist", () => {}, true);

  return (
    <button
      className={clsx(
        styles.wishlistButton,
        isActive && styles.wishlistButton__active,
        className
      )}
      onClick={(e) => {
        e.preventDefault();

        if (!itemId) return;

        toggle(itemId, sizeItemId);

        if (!isActive) {
          modal.openModal();
        }
      }}
    >
      <Heart />
    </button>
  );
};
